import { Box, HStack, Pressable, VStack, Text } from 'native-base'
import { isMobile } from 'react-device-detect'

import { Icon } from '@consumer/ui'
import { packageEvents, errorEvents } from '@consumer/shared'
import { EventLog } from '@consumer/graphql'
import { formatDate, useScreenSize } from '../../utils/displayUtils'
import { DeliveryStatusIcon } from './DeliveryStatusIcon'
import { getEventDetailText } from './event-to-text'
import { mapEventToLabelIcon } from './event-to-icon'

const eventsToShowFacilityInfo = [
  packageEvents.PACKAGE_ARRIVED_AT_FACILITY,
  packageEvents.PACKAGE_DEPARTED_FROM_FACILITY,
  packageEvents.PICKED_UP_FROM_VEHO,
  packageEvents.DROPPED_OFF_AT_VEHO,
]

interface IPackageEventProps {
  trackingId: string
  details: EventLog
  serviceType: string
  clientDisplayName: string
  showBorder: boolean
  isMostCurrentEvent: boolean
  onClick?: () => void
  packageEventLogExpanded?: boolean
  timeZone?: string
  packageHasMultipleEvents?: boolean
}

export const PackageEvent = ({
  trackingId,
  details,
  clientDisplayName,
  showBorder,
  isMostCurrentEvent,
  onClick,
  packageEventLogExpanded,
  timeZone,
  packageHasMultipleEvents,
}: IPackageEventProps) => {
  const screenSize = useScreenSize()

  if (!details) {
    return <></>
  }

  const isMobileScreen = isMobile || screenSize.width < 625
  const isExceptionEvent = (errorEvents as readonly string[]).includes(details.operation)
  const context = mapEventToLabelIcon(details.operation, clientDisplayName, isMostCurrentEvent)

  return (
    <Pressable display="flex" flexDirection="row" key={trackingId + '_' + details?.operation} onPress={onClick}>
      <Box zIndex={1}>
        <DeliveryStatusIcon isError={isExceptionEvent} isLatest={isMostCurrentEvent}>
          {context.icon}
        </DeliveryStatusIcon>
      </Box>
      <Box
        borderLeftColor={showBorder ? '#CCCCCC' : undefined}
        borderLeftStyle={showBorder ? 'dashed' : undefined}
        borderLeftWidth={showBorder ? 'thin' : undefined}
        style={{
          display: 'flex',
          justifyContent: 'flex-start',
          flexGrow: 1,
          marginLeft: -20,
          alignItems: 'center',
        }}
        paddingBottom="16px"
        width="75%"
      >
        <Box position="relative" left="12px" paddingLeft="28px" width="100%" flex={1} alignSelf="flex-start">
          <Box display="flex" flexDirection="row" justifyContent="space-between" alignItems="center">
            <Box display="flex" alignItems="flex-start" flexDirection="column" flex={1} minWidth={0} color="#000000">
              <HStack justifyContent="space-between" alignItems="center" width="100%">
                <VStack>
                  <Box>
                    <Text fontFamily="bodyBold" style={{ fontSize: 14 }} fontWeight={600} color="#000000">
                      {context.label}
                    </Text>
                  </Box>
                  <Box>
                    <Text style={{ fontSize: 14 }} fontWeight={400} color="#000000" marginBottom={2}>
                      {formatDate(details?.timestamp, timeZone)}
                    </Text>
                  </Box>
                </VStack>
                {isMostCurrentEvent && packageHasMultipleEvents && (
                  <Box pr={2} pl={4}>
                    <HStack alignItems="center">
                      {!isMobileScreen && <Text style={{ fontSize: 14, marginRight: 3 }}>View Package History</Text>}
                      <span
                        style={{
                          display: 'inline-flex',
                          transform: packageEventLogExpanded ? 'rotate(180deg)' : undefined,
                        }}
                      >
                        <Icon name="caretDown" />
                      </span>
                    </HStack>
                  </Box>
                )}
              </HStack>
              <Box marginTop="-10px">
                {!isExceptionEvent &&
                  (eventsToShowFacilityInfo as readonly string[]).includes(details?.operation) &&
                  details?.facility && (
                    <Text fontFamily={'Matter SemiBold'} style={{ fontSize: 14 }} fontWeight={400}>
                      {details?.facility?.city}, {details?.facility?.state}
                    </Text>
                  )}
                {isExceptionEvent && packageEventLogExpanded && (
                  <Text
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    style={{ fontSize: 14, textWrap: 'pretty', width: '90%' } as any}
                    flexShrink={1}
                    fontWeight={400}
                    marginBottom={2}
                    color="#000000"
                  >
                    {getEventDetailText(clientDisplayName, details.operation, details.message)}
                  </Text>
                )}
              </Box>
            </Box>
          </Box>
        </Box>
      </Box>
    </Pressable>
  )
}
